<template>
  <div class="bg-silver section-container p-t-20">
    <div class="container">
      <div class="account-container" style="min-height: 600px;">
        <div class="account-sidebar">
          <div class="account-sidebar-cover">
            <!-- <img src="../../assets/color-theme/img/cover/cover-3.jpg" alt=""> -->
          </div>
          <div class="account-sidebar-content">
            <h4>Developer Account</h4>
            <ul class="nav nav-list">
              <li>
                <router-link class="nav-link" :to="{ name: 'DashboardDeveloper'}">Dashboard</router-link>
              </li>
              <li>
                <router-link class="nav-link" :to="{ name: 'ListProductDeveloper'}">My Apps</router-link>
              </li>
              <li>
                <router-link class="nav-link" :to="{ name: 'CreateProductDeveloper'}">Add App</router-link>
              </li>
            </ul>
          </div>
        </div>
        <div class="account-body">
          <router-view></router-view>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'DeveloperLayout'
}
</script>



// WEBPACK FOOTER //
// src/pages/developer/DeveloperLayout.vue